import { ToastMessageType } from '../../domain';
import { ToastMessageQueueService } from '../../services/toastMessageQueueService';
export const template = require('./toastMessage.template');
require('./toastMessage.styles')

export const CUSTOM_TOAST_CLASS = 'sb-toast-notifications';

export class ToastMessageController {
	public static readonly $inject = [
		'sbToastMessageQueueService'
	];

	private readonly messageType = ToastMessageType;

	public minimized = false;

	public get showMinimize() {
		return this.queue.messages.filter(m => m.type === ToastMessageType.progress || m.type === ToastMessageType.action).length > 0;
	}

	constructor(
		// Injecting this so I can use it in the view
		private readonly queue: ToastMessageQueueService
	) { }
}


// WEBPACK FOOTER //
// ./src/sharebase/components/toastMessage/toastMessage.ts